import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	jiraStepLabel: {
		id: 'project-create-importer-upload-flow.common.utils.import-steps.jira.jira-step-label',
		defaultMessage: 'Select software project',
		description: 'Label for jira step in progress tracker',
	},
	jiraBusinessStepLabelNonFinal: {
		id: 'project-create-importer-upload-flow.common.utils.import-steps.jira.jira-business-step-label-non-final',
		defaultMessage: 'Select business project',
		description:
			'Label for first step of the import progress tracker, in which the user selects a Jira business project to import into a software project.',
	},
	jiraSoftwareProjectCreateStepLabelNonFinal: {
		id: 'project-create-importer-upload-flow.common.utils.import-steps.jira.jira-software-project-create-step-label-non-final',
		defaultMessage: 'Create software project',
		description:
			'Label for second step of the import progress tracker, in which the user specifies the details of the Jira software project to be created after import.',
	},
});
